export default {
    slick: {
        config: {
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            speed: 500,
            autoplay: true,
            adaptiveHeight: false,
            nextArrow: "<div class='nextSlide'><i class='icon-arrow-outline-right'></i></div>",
            prevArrow: "<div class='previousSlide'><i class='icon-arrow-outline-left'></i></div>"
        },
        responsive: {
            xl: {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    arrows: true,
                    autoplay: true
                }
            },
            lg: {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: true,
                    autoplay: true
                }
            },
            md: {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    autoplay: true
                }
            },
            sm: {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    autoplay: true
                }
            },
            xs: {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    autoplay: true
                }
            }
        }
    },
    magnificPopup: {
        type: 'image'
    },
    cookieconsent: {
        "//": "You can generate a config for the banner on https://cookieconsent.insites.com/download/",
        palette: {
            popup: {
                background: "#efefef",
                text: "#404040"
            },
            button: {
                background: "#8ec760",
                text: "#ffffff"
            }
        },
        showLink: false,
        theme: "edgeless",
        position: "bottom-right",
        content: {
            message: "Wir verwenden Cookies, damit Sie optimal durch unsere Website navigieren können. ",
            dismiss: "OK"
        }
    }

}